<section class="view-batch-content" [ngSwitch]="activeTab">
  <ng-container *ngSwitchCase="1">
    <div class="info">
      <div class="info-wrapper">
        <div class="info-item">
          <p class="info-item-title">
            {{
              'BATCH_MAILING.BATCHES_TAB.POSTAL_DELIVERY_DIRECTION' | translate
            }}
          </p>
          <p class="info-item-text">
            {{ (DIRECTIONS_MAP.get(batch()?.direction) | translate) || '-' }}
          </p>
        </div>

        <div class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.PAYMENT_TYPE' | translate }}
          </p>
          <p class="info-item-text">
            {{
              (PAYMENT_TYPE_MAP.get(batch()?.payment_type) | translate) || '-'
            }}
          </p>
        </div>

        <div class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.POSTAL_DELIVERY_TYPE' | translate }}
          </p>
          <p class="info-item-text">
            {{
              (POSTAL_TYPE_MAP.get(batch()?.postal_delivery_type)
                | translate) || '-'
            }}
          </p>
        </div>

        <div class="info-item" *ngIf="batch()?.card_number">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.ELS_ACCOUNT' | translate }}
          </p>
          <p class="info-item-text">{{ batch()?.card_number || '-' }}</p>
        </div>

        <div class="info-item" *ngIf="batch()?.postal_delivery_type === 'ems'">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.ATTACHMENT_TYPE' | translate }}
          </p>
          <p class="info-item-text">
            {{ DOCUMENTS_MAP.get(batch()?.is_document) | translate }}
          </p>
        </div>

        <div
          class="info-item"
          *ngIf="batch().postal_delivery_type?.includes('ecommerce')"
        >
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.RECEIVING_IN_OFFICE' | translate }}
          </p>
          <p class="info-item-text">
            {{
              (RECIVING_MAP.get(batch()?.postal_items_in_ops) | translate) ||
                '-'
            }}
          </p>
        </div>

        <div class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.ADDITIONAL_CRITERIA' | translate }}
          </p>
          <p class="info-item-text">
            {{
              (NEGOTIATION_RATE_MAP.get(batch()?.negotiated_rate)
                | translate) || '-'
            }}
          </p>
        </div>

        <div class="info-item">
          <p class="info-item-title">
            {{ 'DELIVERY.DECLARED_VALUE' | translate }}
          </p>
          <p class="info-item-text">
            {{
              batch()?.is_declared_value
                ? ('YES' | translate)
                : ('NO' | translate)
            }}
          </p>
        </div>

        <div class="info-item">
          <p class="info-item-title">
            {{
              'BATCH_MAILING.BATCHES_TAB.GETTING_PART_OF_ATTACHMENT' | translate
            }}
          </p>
          <p class="info-item-text">
            {{
              batch()?.is_partial_receipt
                ? ('YES' | translate)
                : ('NO' | translate)
            }}
          </p>
        </div>

        <div class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.BATCH_WEIGHT' | translate }}
          </p>
          <p class="info-item-text">{{ batch()?.total_weight || '-' }}</p>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="2">
    <section class="mb-2 view-batch-content-search-block">
      <label class="form-control mb-0 flex-1">
        <div class="position-relative">
          <button
            type="button"
            class="postfix icon-button"
            [attr.aria-label]="'SEARCH' | translate"
          >
            <div [inlineSVG]="'assets/img/icons/search-icon-4.svg'"></div>
          </button>
          <input
            type="search"
            id="postal_delivery_search"
            name="postal_delivery_search"
            (input)="searchBatchDepartures($event)"
            class="pr-5"
            [value]="searchParam"
            [placeholder]="
              'BATCH_MAILING.BATCHES_TAB.BATCH_DELIVERY_SEARCH' | translate
            "
            spellcheck="false"
          />
        </div>
      </label>

      <button
        type="button"
        class="button button--outlined"
        *ngIf="batch()?.status === BatchStatusEnum.UNCOMMITED"
        (click)="navigateToCreateDeparturePage()"
      >
        <span
          class="filter-button-icon"
          [inlineSVG]="'assets/img/icons/plus.svg'"
        >
        </span>
        <span class="view-batch-content-search-block-label">
          {{ 'BATCH_MAILING.BATCHES_TAB.ADD_POSTAL_DELIVERY' | translate }}
        </span>
      </button>
    </section>

    <ng-container *ngIf="batchDepartures() as batchItems">
      <ng-container *ngIf="!(batchDeparturesLoading$ | async)">
        <ng-container *ngIf="batchItems.data.length">
          <section
            class="view-batch-content-manage-panel"
            *ngIf="batch()?.status === BatchStatusEnum.UNCOMMITED"
          >
            <div class="checkbox">
              <input
                type="checkbox"
                id="is_all_selected"
                [ngModel]="isAllDeparturesSelected"
                (change)="selectAllCards()"
              />
              <label
                for="is_all_selected"
                class="view-batch-content-select-all"
              >
                <div class="checkbox__el"></div>
                <div class="checkbox__desc">
                  <p class="view-batch-content-select-all h5">
                    {{ 'SELECT_ALL' | translate }}
                  </p>
                </div>
              </label>
            </div>

            <button
              type="button"
              class="filter-button"
              (click)="deleteSelectedDepartures()"
              [disabled]="selectedDepartures.length < 1"
            >
              <fa-icon class="filter-button-icon red" [icon]="faTrashAlt">
              </fa-icon>
              <span class="red">{{ 'DELETE' | translate }}</span>
            </button>
          </section>

          <section class="view-batch-content-list">
            <ng-container
              *ngFor="let batchItem of batchItems.data; let index = index"
            >
              <app-view-batch-card
                [batch]="batch()"
                (deleteDeparture)="sendDeletingDeparturesIds.emit([$event])"
                [batchDeparture]="batchItem"
                (changeCardSelected)="selectSingleDeparture($event)"
              >
              </app-view-batch-card>
            </ng-container>
          </section>
          <app-paginator
            [pageSizeItemKey]="
              'BATCH_MAILING.BATCHES_TAB.VIEWING_BATCH.PAGINATION_ITEM_KEY'
            "
            [localStorageKey]="'batch-departures-per-page'"
            (pageChange)="pageChanged($event)"
            [items]="convertInputData(batchItems)"
          >
          </app-paginator>
        </ng-container>
      </ng-container>
    </ng-container>

    <section
      *ngIf="batchDeparturesLoading$ | async"
      class="text-secondary text-center"
    >
      <div class="spinner-border spinner-border-lg" role="status">
        <span class="sr-only">{{ 'LOADING' | translate }}</span>
      </div>
    </section>
  </ng-container>

  <ng-container *ngSwitchCase="3">
    <article class="info">
      <section class="info-wrapper-sender">
        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.COMPANY_UNP' | translate }}
          </p>
          <p class="info-item-text">{{ batch()?.trn || '-' }}</p>
        </section>

        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.COMPANY_NAME' | translate }}
          </p>
          <p class="info-item-text">{{ (session$ | async)?.name || '-' }}</p>
        </section>

        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.BRANCH_CODE' | translate }}
          </p>
          <p class="info-item-text">{{ (session$ | async)?.filial || '-' }}</p>
        </section>

        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.SENDER_IBAN' | translate }}
          </p>
          <p class="info-item-text">{{ batch()?.iban || '-' }}</p>
        </section>

        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.SENDER_BIK' | translate }}
          </p>
          <p class="info-item-text">
            {{ (session$ | async)?.default_legal_info?.bic || '-' }}
          </p>
        </section>

        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.BANK_NAME' | translate }}
          </p>
          <p class="info-item-text">{{ batch()?.bank || '-' }}</p>
        </section>

        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.SENDER_PHONE' | translate }}
          </p>
          <p class="info-item-text">
            {{ batch()?.phone ? checkPhonePrefix(batch()?.phone) : '-' }}
          </p>
        </section>

        <section class="info-item">
          <p class="info-item-title">
            {{ 'BATCH_MAILING.BATCHES_TAB.SENDER_EMAIL' | translate }}
          </p>
          <p class="info-item-text">{{ batch()?.email || '-' }}</p>
        </section>
      </section>
      <section class="info-item">
        <p class="info-item-title">{{ 'SENDER_FULL_ADDRESS' | translate }}</p>
        <p class="info-item-text">{{ batch()?.address }}</p>
      </section>
    </article>
  </ng-container>
</section>
